import React from 'react';
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

const PaymentFailed = ({ onRetry }) => {
  return (
    <Box
      minH="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      px={4}
    >
      <VStack
        bg="white"
        p={10}
        rounded="2xl"
        shadow="xl"
        spacing={6}
        textAlign="center"
      >
        <Icon as={WarningIcon} boxSize={16} color="red.400" />
        <Heading size="lg" color="red.500">
          Payment Failed
        </Heading>
        <Text fontSize="md" color="gray.600">
          Oops! Something went wrong. Please check your payment details and try again.
        </Text>
      </VStack>
    </Box>
  );
};

export default PaymentFailed;
